<!--
 * @Description: 重要度排序 - 查询页面跳转用
 * @Author: maqinghe 
 * @Date: 2023年05月29日 10:15:49
-->
<template>
  <div class='importance-page atb-flex atb-flex-column'>
    <div class='container atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native.native="getList(1)" @submit.native.prevent>
          <el-form-item label="姓名">
            <selecter v-model="searchParam.WkNo" clearable></selecter>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>

          <el-form-item v-if="!isApprove && !isSearchEnter">
            <el-button type="export" @click="commitTip">提交</el-button>
          </el-form-item>
          <el-form-item v-if="!isApprove && !isSearchEnter">
            <el-button type="refuse" @click="isShowRevert = true">撤回</el-button>
          </el-form-item>
          <el-form-item v-if="!isApprove && !isSearchEnter">
            <el-button type="downloadTemplate" @click="isShowApprove = true">审批意见</el-button>
          </el-form-item>
          <el-form-item v-if="isApprove && !isSearchEnter">
            <el-button :disabled="this.role == 2" type="primary" @click="isShowAccess = true">通过</el-button>
          </el-form-item>
          <el-form-item v-if="isApprove && !isSearchEnter">
            <el-button :disabled="this.role == 2" type="refuse" @click="isShowRefuse = true">驳回</el-button>
          </el-form-item>
          
          <el-form-item v-if="!isApprove && !isSearchEnter">
            <el-button type="primary" @click="showFactor">因素管理</el-button>
          </el-form-item>

          <el-form-item>
            <el-button type="downloadTemplate" plain @click="exportExcel">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-grid
          class='atb-table header-table edit-table border-table'
          border='full'
          stripe
          height='100%'
          auto-resize
          :data="tableData"
          ref="tableGrid"
          :columns="columns"
          :seq-config="{ seqMethod }"
          :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeCellMethod }"
          :column-config="{ resizable: true }"
          @edit-closed="editClosed"
          :edit-rules="validRules"
          @cell-click="expandRow"
        >
          <template v-for="col in dynamicColumns" v-slot:[col.field]="{ row }">
            <!-- <el-input-number v-model="row[col.field]" :min="0" :max="100" :controls="false"></el-input-number> -->
            <!-- <el-select v-model="row[col.field]">
              <el-option v-for="score in scoreList" :key="score.value" :label="score.value" :value="score.value"></el-option>
            </el-select> -->
            <!-- <vxe-select v-model="row[col.field]" placeholder="请选择">
              <vxe-option v-for="score in scoreList" :key="score.value" :value="score.value" :label="score.value"></vxe-option>
            </vxe-select> -->
            <el-autocomplete
              @change="rowScoreChange(row, col.field)"
              v-model.trim="row[col.field]"
              :fetch-suggestions="scoreSearch"
              @select="(itemScore) => handleScoreSelect(itemScore, row)"
              maxlength="3"
              popper-class="score-select-panel"
            ></el-autocomplete>
          </template>
          <template v-for="col in dynamicColumns" v-slot:[col.headerSlot]="{ column }">
            <span>{{ column.title }}</span>
            <el-popover
              width="300"
              trigger="hover"
              v-if="col.remark"
            >
              <span slot="reference" class="factor-tip"><i class="el-icon-info"></i></span>
              <pre class="factor-tip-content">
                {{ col.remark }}
              </pre>
            </el-popover>
          </template>
          <template v-slot:remark="{ row }">
            <el-input type="textarea" autosize v-model="row.remark"></el-input>
          </template>
          <template v-slot:remarkEl="{row}">
            <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remark }}</div>
          </template>
          <template v-slot:scoreHeader="{ column }">
            <div style="display: inline-block;">
              <span>{{ column.title }}</span>
              <span>(</span>
              <el-popover
                width="600"
                trigger="hover"
              >
                <span slot="reference" class="rank-tip">评分标准</span>
                <table class="rank-tip-table">
                  <thead>
                    <tr>
                      <th width="60" align="center">标准</th>
                      <th width="80" align="center">分值区间</th>
                      <th align="center">标准说明</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td align="center">出色</td>
                      <td align="center">100<br/>95</td>
                      <td>日常工作始终高标准完成，能独立解决工作中出现的所有问题，并能为其找出最优解，减少问题出现。通常具有下列表现：始终高质量、高效率完成工作，能独立解决工作问题并使其减少，得到来自客户的高度评估。</td>
                    </tr>
                    <tr>
                      <td align="center">优良</td>
                      <td align="center">90<br/>85</td>
                      <td>日常工作经常高标准完成，并能独立解决工作中出现的所有问题。常具有下列表现：经常高质量、高效率完成日常工作，可及时解决工作中出现的问题，客户满意。</td>
                    </tr>
                    <tr>
                      <td align="center">可接受</td>
                      <td align="center">80<br/>75</td>
                      <td>日常工作可以正常完成，并能独立解决工作中出现的大部分问题。通常具有下列表现；日常工作可以达到工作标准，可解决工作中出现的问题，客户基本满意。</td>
                    </tr>
                    <tr>
                      <td align="center">需改进</td>
                      <td align="center">70<br/>65</td>
                      <td>基本满足日常工作的需要，在别人的帮助下才能解决工作中出现的问题。通常具有下列表现：偶有小的疏漏，有时达不到工作标准，偶尔有客户的投诉，工作中的问题完全无法独立解决。</td>
                    </tr>
                    <tr>
                      <td align="center">不良</td>
                      <td align="center">60<br/>30<br/>0</td>
                      <td>不能满足日常工作的需要，通常具有以下表现：经常出现工作失误，达不到工作标准，经常有投诉发生。</td>
                    </tr>
                  </tbody>
                </table>
              </el-popover>
              <span>)</span>
            </div>
          </template>
          <template v-slot:status="{ row }">
            <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
              {{ statusMap[row.status] || '' }}
            </el-tag>
            <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
              {{ statusMap[row.status] || '' }}
            </el-tag>
            <el-tag v-else type="ongoing" effect="dark">
              {{ statusMap[row.status] || '' }}
            </el-tag>
          </template>
          <template v-slot:rankHeader="{ column }">
            <div>
              <span>{{ column.title }}</span>
              <span>(</span>
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                :content="rankContent">
                <span slot="reference" class="rank-tip">注意事项</span>
                <pre style="white-space: pre-line;">
                  {{ rankContent }}
                </pre>
              </el-popover>
              <span>)</span>
            </div>
          </template>
        </vxe-grid>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="handlePageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
      </div>
    </div>

    <el-dialog title="提交" :visible.sync="isShowSubmit" width="260px">
      <div class="content sub-content">
        <h2>确定要提交吗?</h2>
        <p>提交后无法修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowSubmit = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="isShowRevert"
      width="300px"
      @close="closeRevert"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <h2>确定要撤回吗?</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="revert()">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowRevert = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="isShowAccess"
      width="500px"
      @close="closeAccess"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" :maxlength="$config.input.textareaMaxLength" placeholder="请填写审批通过原因" v-model="approveReason"> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="approve('access')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowAccess = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="isShowRefuse"
      width="500px"
      @close="closeRefuse"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" :maxlength="$config.input.textareaMaxLength" placeholder="请填写审批驳回原因" v-model="approveReason"> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="approve('refuse')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowRefuse = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="isShowApprove"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <p style="text-align:left;line-height: 18px;">{{approveReasonText || '无'}}</p>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button class="atb-dialog-cancel" type="primary" @click="isShowApprove = false">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="因素管理" :visible.sync="isShowFactor" width="800px" @close="closeFactor">
      <div class="content">
        <div style="line-height: 1.5;margin-bottom: 10px;">
          <pre style="white-space: pre-line;">
            {{ factorTip }}
          </pre>
        </div>
        <vxe-table
          class='atb-table header-table edit-table'
          stripe
          border='full'
          max-height='450'
          auto-resize
          resizable
          :data="factorTableData"
          ref="factorTable"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: factorActiveCellMethod }"
          :edit-rules="factorValidRules"
          @cell-click="expandRowFactor"
        >
          <vxe-table-column field="factorName" title="因素名" :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-input placeholder="因素名" v-model="row.factorName"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="factorWeight" title="权重(%)" :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-input-number placeholder="权重" :min="1" :max="20" v-model="row.factorWeight" :controls="false"></el-input-number>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remark" title="说明" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="说明" v-model="row.remark"></el-input>
            </template>
            <template #default="{ row }">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remark }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="sort" title="因素排序" :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-input-number placeholder="因素排序" :min="0" v-model="row.sort" :controls="false"></el-input-number>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" class-name='operation' width="80">
            <template #header="{ column }">
              <span>{{ column.title }}</span>
              <el-tooltip class='add-factor' effect='dark' content='新增' placement="top">
                <i class="icon-add" @click="addFactor"></i>
              </el-tooltip>
            </template>
            <template #default="scope">
              <el-tooltip class='item' effect='dark' content='删除' placement="bottom" v-if="scope.row.type !== 0">
                <i class='icon-close delete' @click.stop='deleteFactor(scope)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="addFactor">新增</el-button>
        <el-button class="atb-dialog-confirm" type="primary" @click="saveFactor">保存</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowFactor = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import _ from 'lodash';
  import { PERIODS, IMPORTANCE_STATE } from '@/utils/period-enum.js';
  import routeMixin from '@/mixins/route.mixin'
  
  export default {
    name: "ImportanceSearchDetail",
    inject: ["reload"],
    mixins: [routeMixin],
    components: {
      selecter: () => import('@/component/global/customerSelect'),
    },

    data() {
      return {
        validRules: {},
        wkNo: '', // 排序人工号
        msgId: '',
        role: 1,
        isShowSubmit: false,
        
        disabled: true,
        allowEdit: true,
        row: {},
        rowIndex: 0,
        editStatus: 'edit',
        statusMap: IMPORTANCE_STATE,

        periods: PERIODS,

        currWkNo: '',
        searchParam: {
          WkNo: ''
        },
        year: undefined,
        period: undefined,
        cacheEditValue: '',
        tableData: [],
        tempTableData: [],
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        defaultColumns: [
          { type: 'seq', title: 'NO.', width: 50 },
          { field: 'period', title: '期次', width: 100, formatter: ({row}) => {return `${row.year}${this.periods[row.period]}`}  },
          { field: 'wkName', title: '姓名', width: 140, formatter: ({row}) => {return `${row.wkName}(${row.wkNo})`} },
          { field: 'score', title: '总分', width: 130, slots: { header: 'scoreHeader'} },
          { field: 'sort', title: '排名', width: 130, slots: { header: 'rankHeader' } },
          { field: 'remark', title: '备注', minWidth: 200, isEditable: true, editRender: { autofocus: '.el-textarea__inner' }, slots: { edit: 'remark', default: 'remarkEl' } },
          { field: 'status', title: '状态', width: 80, slots: { default: 'status' } },
        ],
        dynamicColumns: [],
        columns: [],

        isShowApprove: false,
        approveContent: '',

        rankContent: '',

        isShowFactor: false,
        factorTableData: [],
        _factorTableData: [], // 因素原始数据
        factorValidRules: {
          factorName: [{ required: true,  message: '"因素名"为必填项' }],
          factorWeight: [{ required: true, validator: ({ cellValue }) => { if (!cellValue && cellValue !== 0) { return new Error('"权重"为必填项') }}}],
        },

        isShowRevert: false,
        factorMin: 6,
        factorMax: 8,
        factorTip: '',
        
        isShowAccess: false,
        isShowRefuse: false,
        showRevert: false,
        approveReason: '',
        approveReasonText: '',

        isFirst: true,
        scoreList: [
          { value: 100 },
          { value: 95 },
          { value: 90 },
          { value: 85 },
          { value: 80 },
          { value: 75 },
          { value: 70 },
          { value: 60 },
          { value: 30 },
          { value: 0 }
        ],

        isSearchEnter: true,

        isApprove: false
      }
    },

    watch: {
      $route(){
        this.reload();
      },
      // 因素列添加校验函数
      dynamicColumns: {
        handler(newValue) {
          this.validRules = {};
          let rules = {};
          if (newValue && newValue.length > 0) {
            newValue.forEach(column => {
              rules[column.field] = [
                {
                  required: true,
                  validator: ({cellValue, row}) => {
                    if (!cellValue && cellValue !== 0) {
                      return new Error('"' + column.name + '"为必填项')
                    } else if (!this.scoreList.find(item => item.value == cellValue)) {
                      return new Error('未输入下拉分值')
                    }
                  }
                }
              ]
            });
            this.validRules = rules;
          }
        },
        immediate: true
      }
    },
    created() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';

      this.year = this.$route.query.year || undefined;
      this.period = this.$route.query.period || undefined;

      this.wkNo = this.$route.query.wkNo || '';
      this.msgId = this.$route.query.msgId || '';
      this.role = this.$route.query.role || 1;
      // this.isSearchEnter = this.$route.query.search;
      this.isApprove = this.$route.query.editStatus || false;

      this.getDictData();
    },
    mounted() {
      this.getData();
    },
    methods: {
      // 格式化序列号
      seqMethod({ rowIndex }) {
        return rowIndex + (this.page.PageIndex - 1) * this.page.PageSize + 1;
      },
      getData() {
        Promise.all([this.getFactorColumn(), this.getList()]).then(res => {
          const factorColumns = res[0];
          const commitedFactorColumns = res[1];
          if (commitedFactorColumns && commitedFactorColumns.length > 0) {
            this.dynamicColumns = commitedFactorColumns;
          } else {
            this.dynamicColumns = factorColumns;
          }
          this.concatColumn();
        });
      },
      // 获取因素列，未提交时取此接口数据
      getFactorColumn() {
        return this.$ajax.get(this.$api.period.importanceFactor.column, {
          WkNo: this.wkNo,
          Pram: this.isFirst ? 'first' : undefined
        }).then((res) => {
          let list = res.data.importanceFactorListDto || [];
          list.sort((a, b) => (a.type - b.type || a.sort - b.sort));
          let columns = [];
          list.forEach(item => {
            columns.push({
              field: item.id,
              title: `${item.factorName}(${item.factorWeight}%)`,
              name: item.factorName,
              weight: item.factorWeight,
              sort: item.sort,
              width: 175,
              isEditable: true,
              remark: item.remark,
            });
          });

          // 权重和不等于100，弹出因素管理，从查询页面跳转过来时不弹
          let isWeight = res.data.isWeight;
          if (!isWeight && this.isFirst && !this.isSearchEnter) {
            this.isFirst = false;
            this.showFactor();
          }
          return columns;
        });
      },
      // 固定列、动态列(因素)合并
      concatColumn() {
        // 动态列添加可编辑处理
        this.dynamicColumns.forEach(col => {
          if (col.isEditable) {
            this.$set(col, 'editRender', { autofocus: '.el-input__inner' });
            this.$set(col, 'slots', { edit: col.field, header: `${col.field}Header` });
            this.$set(col, 'headerSlot', `${col.field}Header`);
          }
        });
        let cols = [...this.defaultColumns.slice(0, 3), ...this.dynamicColumns, ...this.defaultColumns.slice(3)];
        this.columns = cols;
      },
      
      // 获取表格数据
      getList(resetPage) {
        if (resetPage) {
          this.page.PageIndex = 1;
        }
        
        this.tableData = [];
        let param = {...this.searchParam, LoginWkNo: this.wkNo, Year: this.year || undefined, Period: this.period || undefined, ...this.page};
        return this.$ajax.get(this.$api.period.importanceSort.search, param).then((res) => {
          let rows = res.data.rows.importantSort || [];
          this.approveReasonText = rows.length > 0 ? rows[0].approveReason : '';
          
          rows.forEach(row => {
            let factorScoreList = row.importanceScoreList || [];
            factorScoreList.forEach(factor => {
              row[factor.factorId] = factor.itemScore;
            });
          });
          this.total = res.data.total;
          this.tableData = rows;

          // 提交后的因素列，取此字段，不取因素列接口的数据
          let commitedFactors = res.data.rows.selfFactors || '[]';
          commitedFactors = JSON.parse(commitedFactors);
          let columns = [];
          if (commitedFactors.length > 0) {
            commitedFactors.forEach(item => {
              columns.push({
                field: item.Id,
                title: `${item.FactorName}(${item.FactorWeight}%)`,
                name: item.FactorName,
                weight: item.FactorWeight,
                sort: item.Sort,
                width: 175,
                remark: item.Remark,
                isEditable: true,
              });
            });
          }
          columns.sort((a, b) => (a.type - b.type || a.sort - b.sort));
          return columns;
        });
      },
      handlePageChange({currentPage}) {
        this.page.PageIndex = currentPage;
        this.getList();
      },
      activeCellMethod({ row }) {
        if (this.isSearchEnter || !row.isEdit) return false;
        // 缓存当前行的值，如果没有变动，则不调接口
        let cacheRow = {};
        this.dynamicColumns.forEach(col => {
          cacheRow[col.field] = row[col.field];
        });
        cacheRow.remark = row.remark;
        cacheRow.id = row.id;
        this.cacheEditValue = cacheRow;
        return true;
      },
      async editClosed({row}) {
        let isValidError = false;
        for (let i = 0; i < this.dynamicColumns.length; i++) {
          const field = this.dynamicColumns[i].field;
          if (row[field] !== 0 && row[field]) {
            const score = this.scoreList.find(item => item.value === row[field])
            if (!score) {
              isValidError = true;
              break;
            }
          }
        }
        if (isValidError) {
          this.$refs.tableGrid.validate(row);
          return false;
        }
     
        let currentRow = {};
        this.dynamicColumns.forEach(col => {
          currentRow[col.field] = row[col.field];
        });
        currentRow.remark = row.remark;
        currentRow.id = row.id;
        if (JSON.stringify(this.cacheEditValue) === JSON.stringify(currentRow) || this.cacheEditValue.id !== currentRow.id) {
          return false;
        }
        let factors = [];
        this.dynamicColumns.forEach(col => {
          factors.push({
            sortId: row.id,
            factorId: col.field,
            itemScore: row[col.field] === '' ? undefined : row[col.field]
          });
        });
        let params = {
          importanceScoreListSave: factors,
          remark: row.remark
        };
        this.$ajax.post(this.$api.period.importanceSort.save, params).then(() => {

          this.$message.success("保存成功");
          this.getList();
          
          // let updateScoreRank = res.data || [];

          // this.tableData.forEach(r => {
          //   let update = updateScoreRank.find(updateRow => updateRow.sortId === r.id);
          //   if (update) {
          //     r.score = update.score;
          //     r.sort = update.sort;
          //   }
          // });
        });

      },


      getDictData() {
        this.$ajax.get(this.$api.common.getDict, { ItemType: 'ImportanceFactorRemark' }).then((res)=>{
          if(res.code === 0) {
            let list = (res.data && res.data.rows) || [];
            list.forEach(item => {
              switch (item.itemKey) {
                case 'FactorLimitMin':
                  this.factorMin = parseInt(item.itemValue);
                  break;
                case 'FactorLimitMax':
                  this.factorMax = parseInt(item.itemValue);
                  break;
                case 'ScoreSort':
                  this.rankContent = item.itemDesc;
                  break;
                case 'FactorManage':
                  this.factorTip = item.itemDesc;
                  break;
                default:
                  break;
              }
            });
          }
        });
      },
      
      // 因素管理
      showFactor() {
        // 审批时不显示
        if (this.isApprove) return;
        this.getFactor();
        this.isShowFactor = true;
      },
      closeFactor() {
        this.isShowFactor = false;
        this.getData();
        this.validateWeightSum();
      },
      validateWeightSum() {
        let sum = this._factorTableData.reduce((init, item) => {
          return init + item.factorWeight;
        }, 0);
        if (sum < 100) {
          this.$message.error("已保存的因素权重不足100%，需修改");
        } else if (sum > 100) {
          this.$message.error("已保存的因素权重超出100%，需修改");
        }
      },
      
      getFactor() {
        return this.$ajax.get(this.$api.period.importanceFactor.list).then((res) => {
          let list = res.data || [];
          list.sort((a, b) => (a.type - b.type || a.sort - b.sort));
          let columns = [];
          list.forEach(item => {
            columns.push({
              // factorName: item.factorName,
              // id: item.id,
              // factorWeight: item.factorWeight,
              // remark: item.remark || '',
              // sort: item.sort,
              // type: item.type,
              ...item,
            });
          });
          this.factorTableData = columns;
          this._factorTableData = JSON.parse(JSON.stringify(columns));
        });
      },
      // 因素管理 - 部分单元格禁止编辑
      factorActiveCellMethod({row}) {
        if (row.type === 0) {
          return false;
        }
        return true;
      },
      deleteFactor({rowIndex, row}) {
        if (row.id) {
          this.$ajax.delete(this.$api.period.importanceFactor.delete + `/${row.id}`).then(() => {
            this.$message.success("删除成功");
            this.factorTableData.splice(rowIndex, 1);
          });
        } else {
          this.factorTableData.splice(rowIndex, 1);
        }
      },
      // 因素管理 - 新增因素
      addFactor() {
        if (this.factorTableData.length >= this.factorMax) {
          this.$message.error(`全部因素不能超过${this.factorMax}个`);
          return;
        }

        let sort = this.factorTableData[this.factorTableData.length - 1].sort + 1;
        this.factorTableData.push({
          factorName: '',
          factorWeight: null,
          remark: '',
          sort: sort,
          type: 1
        });
      },
      // 因素管理保存
      async saveFactor() {
        const $table = this.$refs.factorTable;
        let errMap = await $table.validate(true).catch(errMap => errMap);
        if (!errMap) {
          errMap = 1;
          let factorList = this.factorTableData.filter(item => item.type !== 0);
          if (factorList.length === 0) {
            this.calcWeightSum();
            return;
          }
          this.$ajax.post(this.$api.period.importanceFactor.update, factorList).then(() => {
            this.calcWeightSum();
            this.getFactor().then(() => {
              this.$ajax.post(this.$api.period.importanceSort.recalc, {
                loginWkNo: this.currWkNo,
                year: this.year || undefined,
                period: this.period || undefined,
                recalculateDetail: this.factorTableData.map(factor => { return {factorId: factor.id, factorWeight: factor.factorWeight} })
              });
            });
          });
        }
      },
      calcWeightSum() {
        let sum = this.factorTableData.reduce((init, item) => {
          return init + item.factorWeight;
        }, 0);
        if (sum < 100) {
          this.$message.error("已保存，权重不足100%，需修改");
        } else if (sum > 100) {
          this.$message.error("已保存，权重超出100%，需修改");
        } else {
          this.$message.success("已保存");
        }
      },
      commitTip() {
        this.$nextTick(async () => {
          const $table = this.$refs.tableGrid;
          const errMap = await $table.validate(true).catch(errMap => errMap)
          if (!errMap) {
            this.isShowSubmit = true;
          }
        })
      },
      
      submit() {
        this.$ajax.post(this.$api.period.importanceSort.submit).then((res) => {
          this.getList();
          this.$message.success("提交成功");
        }).finally(() => {
          this.isShowSubmit = false;
        });
      },
      // 撤回
      revert() {
        this.isShowRevert = false;
        this.$ajax.put(this.$api.period.importanceSort.revert).then(() => {
          this.getList();
          this.$message.success("撤回成功");
        });
      },
      closeRevert() {

      },
      approve(action) {
        let param = {
          msgId: this.msgId,
          remark: this.approveReason
        };
        if (action === "access") {
          param.status = 30;
          this.isShowAccess = false;
        } else {
          param.status = 10;
          if (!this.approveReason) {
            this.$message.error("必须填写驳回原因！");
            return false;
          }
          this.isShowRefuse = false;
        }
        this.$ajax.put(this.$api.period.importanceSort.updateStatus, param).then(() => {
          this.$message.success("审批成功");
          this.reload();
        });
      },
      closeRefuse() {
        this.approveReason = '';
      },
      closeAccess() {
        this.approveReason = '';
      },
      expandRow({ row, rowIndex }) {
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.tableGrid.updateData(this.tableData);
      },
      expandRowFactor({ row, rowIndex }) {
        this.factorTableData[rowIndex].expandRowFlag = !this.factorTableData[rowIndex].expandRowFlag;
        this.$refs.factorTable.updateData(this.factorTableData);
      },
      exportExcel() {
        let param = Object.assign({loginWkNo: this.wkNo, Year: this.year || undefined, Period: this.period || undefined}, this.searchParam);
        this.$ajax.post(this.$api.period.importanceSort.export, param, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = '重要度排序'
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },
      rowScoreChange(row, field) {
        let val = row[field];
        if (!val) val = "";
        val = val.replace(/[^\d]/g, '');
        val = val && parseInt(val);
        if (val - 0 > 100) {
          val = 100;
        }
        if (val - 0 < 0) {
          val = 0;
        }
        row[field] = val;
        this.$refs.tableGrid.validate(row);
      },
      scoreSearch(queryString, cb) {
        let programList = this.scoreList;
        // 调用 callback 返回建议列表的数据
        cb(programList);
      },
      handleScoreSelect(score, row) {
        this.$refs.tableGrid.validate(row);
      }
    },
  }
</script>
<style scoped lang='scss'>
  .importance-page {
    height: 100%;
    .container {
      padding: 24px;
      flex: 1;
      ::v-deep .atb-table {
        .main-row {
          .vxe-cell {
            padding: 0;
          }
        }
      }
    }
    ::v-deep .el-dialog__body {
      padding-top: 20px !important;
      text-align: left;
      .sub-content{
        text-align: center;
      }
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: right;
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
  }
  .add-factor {
    margin-left: 5px;
    font-size: 16px;
    cursor: pointer;
    color: $--color-primary;
    vertical-align: -1px;
    &:hover {
      opacity: 0.8;
    }
  }
  .rank-tip {
    color: $--color-primary;
  }
  .rank-tip-table {
    border-collapse: collapse;
    font-size: 13px;
    color: #222;
    td, th {
      padding: 10px ;
      border: 1px solid #ccc;
    }
  }
  .factor-tip {
    margin-left: 2px;
    color: #aaa;
    vertical-align: bottom;
    &:hover {
      color: #888;
    }
  }
  .factor-tip-content {
    color: #222;
    white-space: pre-line;
  }
</style>
<style>
.el-autocomplete-suggestion.score-select-panel {
  margin: 6px 0;
}
</style>